export enum ACCOUNT_SETTING_SELECTION {
	MANAGE_EMAIL = 'MANAGE_EMAIL',
	MANAGE_PASSWORD = 'MANAGE_PASSWORD',
	MANAGE_2FA = 'MANAGE_2FA',
}

export interface SectionEditMode {
	isEditModeEnabled: boolean;
	setIsEditModeEnabled: (enabled: boolean) => void;
}
